module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074ac_banner_800x600.3c3ca9fd.png";